<template>
  <div class="notifications__container">
    <b-col>
      <b-row
        ><b-col cols="10"
          ><h3 class="font-weight-bold pt-4">Notifications</h3></b-col
        >
        <b-col class="pt-2 pl-4"
          ><b-button variant="transparent" class="px-0" @click="$emit('close')"
            ><b-icon icon="x" font-scale="1"></b-icon></b-button></b-col
      ></b-row>
    </b-col>
    <div v-if="notifications.length > 0" class="notifications__list">
      <b-list-group v-for="notif in notifications" :key="notif.id">
        <b-list-group-item
          class="pr-0 py-3"
          :class="{ unread: notif.read === false }"
        >
          <b-row>
            <b-col cols="2" class="px-0 pl-2">
              <b-img
                v-if="notif.type === 'expiringfilenotification'"
                center
                class="image"
                :src="fileSrc(notif)"
              ></b-img>
              <b-avatar
                v-else
                variant="primary"
                class="avatar"
                :src="fileSrc(notif)"
              ></b-avatar>
            </b-col>
            <b-col
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              type="button"
              @click="goToFile(notif)"
              ><b-row>{{ notif.message }}</b-row>
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>
            <b-col
              ><b-button
                variant="transparent"
                class="px-0 pt-0 pb-3"
                @click="markAsRead(notif)"
                ><b-icon icon="x" font-scale="1"></b-icon></b-button
            ></b-col> </b-row
        ></b-list-group-item>
      </b-list-group>
    </div>
    <b-col v-else class="notifications__empty">
      <b-row><h3 class="font-weight-bold">No notifications yet!</h3></b-row>
      <b-row>
        <h6 class="gray--3 text-center">
          We will notify you once we have something for you.
        </h6>
      </b-row>
    </b-col>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters('notification', ['notifications'])
  },
  methods: {
    ...mapActions({
      getNotifications: 'notification/getNotifications',
      getFile: 'file/getFile'
    }),
    fileSrc(notif) {
      return notif.type === 'expiringfilenotification'
        ? notif.data.data.type
          ? notif.data.data.object_thumbnail
          : notif.data.data.object_thumbnail
        : notif.data.data.actor_thumbnail
    },
    uploaded(notif) {
      return this.getTimeDiff(notif.created_at)
    },
    async goToFile(notif) {
      this.markAsRead(notif)

      if (notif.type === 'filerequestnotification') {
        this.$router
          .replace({
            name: 'requests.list-page'
          })
          .catch(() => {})
      } else {
        await this.getFile(notif.data.data.id)
        this.$router
          .replace({
            name: 'file.view-page',
            params: {
              id: notif.data.data.id
            }
          })
          .catch(() => {})
      }
    },
    async markAsRead(notif) {
      await this.$api
        .put('notifications', {
          notification_id: notif.id
        })
        .then(({ data }) => {
          if (data.success === true) {
            this.getNotifications()
            this.$emit('close')
          }
        })
    }
  },
  created() {
    this.getNotifications()
  }
}
</script>
<style lang="scss" scoped>
.notifications {
  &__container {
    position: fixed;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00429d0d;
    border: 1px solid #b6c3d94d;
    border-radius: 8px 0px 0px 8px;
    opacity: 1;
    width: 400px;
    z-index: 1000;
    right: 0%;
    top: 9%;

    @media (max-width: 767px) {
      top: 0;
      width: 85%;
      min-height: 100%;
      box-shadow: 0px 3px 5px #00429d0d;
      border: 0.5px solid #969eaa80;
      border-radius: 0;
    }
  }

  &__list {
    max-height: 82vh;
    overflow-y: visible;
    overflow-x: hidden;
  }

  &__empty {
    height: 85vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.list-group-item {
  border-top: none;
  border-left: none;
  border-right: none;

  &:hover,
  &:focus,
  &:active {
    background-color: #eaf3ff !important;
    color: #006cff !important;
  }
}

.unread {
  background-color: #eaf3ff !important;
  color: #006cff !important;
}
.b-icon.bi {
  color: #b8bcc6;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatar {
  width: 3.5em !important;
  height: 3.5em !important;
}
</style>
